import { clsxm } from "@/utils/clsxm";

interface IProps {
  max?: number;
  current?: number;
  className?: string;
}

const SlidesProgress = ({ max = 1, current = 1, className = "" }: IProps) => (
  <div className={clsxm("flex flex-col gap-4", className)}>
    <div className="flex flex-row flex-nowrap justify-between gap-2">
      {Array.from({ length: max }).map((_, index) => (
        <div
          key={index}
          className={clsxm(
            "w-full h-2 rounded-[20px]",
            index < current
              ? "bg-new-design-purple-300"
              : "bg-new-design-gray-600/[0.08]"
          )}
        />
      ))}
    </div>
  </div>
);

export { SlidesProgress };
